<p-dialog
        [modal]="true"
        (onShow)="showDialog()"
        (onHide)="close()"
        [(visible)]="dialogVisible"
        [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
        [style]="{ width: '90vw', height: '90vh', maxHeight: '90vh' }"
        [draggable]="false"
        [resizable]="false"
        [dismissableMask]="true">
    <ng-template pTemplate="header">
        <div class="header">
            <div class="button-group">
                <p-button
                        *ngIf="this.canvas && this.canvas.getObjects().length > 0"
                        [pTooltip]="'Crop image'"
                        icon="pi pi-expand"
                        [disabled]="this.croppingRect"
                        (click)="createCroppingRect()"/>
                <p-button
                        [pTooltip]="'Draw a arrow'"
                        icon="pi pi-arrow-up"
                        [severity]="isDrawable.arrow ? 'success' : 'primary'"
                        (click)="enableDrawingMode('arrow')"/>
                <p-button
                        [pTooltip]="'Draw a circle'"
                        icon="pi pi-circle-fill"
                        [severity]="isDrawable.circle ? 'success' : 'primary'"
                        (click)="enableDrawingMode('circle')"/>
            </div>

            <div class="dropdown-group flex gap-2">
                <!-- Fill Color Dropdown -->
                <p-dropdown
                        [options]="fillColors"
                        [(ngModel)]="props.fill"
                        optionLabel="red"
                        (onChange)="changeFillOfSelectedObjects()"
                        [style]="{'width':'75px', 'height': '40px', 'backgroundColor': props.fill, 'color': props.fill, 'border': '1px solid '+ props.fill}">
                    <ng-template let-color pTemplate="item">
                        <div class="color-option" [style]="{'backgroundColor': color, 'color': color}">⠀</div>
                    </ng-template>
                </p-dropdown>

            </div>

            <div class="button-group">
                <!-- Clear All Button -->
                <p-button
                        [pTooltip]="'Clear all'"
                        icon="pi pi-times"
                        severity="danger"
                        [disabled]="!this.canvas || this.canvas.getObjects().length === 0"
                        (click)="clearAll()"/>
                <p-button
                        [pTooltip]="'Delete selected elements'"
                        icon="pi pi-trash"
                        severity="danger"
                        [disabled]="!this.canvas || this.canvas.getActiveObjects().length === 0"
                        (click)="clearActiveObject()"/>
                <p-button
                        *ngIf="this.canvas && this.canvas.getObjects().length > 0"
                        [pTooltip]="'Download image'"
                        icon="pi pi-download"
                        (click)="downloadImage()"/>

                <p-button
                        *ngIf="this.croppingRect"
                        [pTooltip]="'Apply crop'"
                        severity="success"
                        icon="pi pi-check"
                        (click)="cropImage()"/>
                <p-button
                        *ngIf="this.isCropped"
                        [pTooltip]="'Reset to initial image'"
                        severity="danger"
                        icon="pi pi-undo"
                        (click)="resetToOriginalImage()"/>
            </div>
            <div class="slider-group w-10rem" *ngIf="isDrawable.arrow">
                <p class="mb-2">Stroke: </p>
                <p-slider [(ngModel)]="arrowStrokeWidth" [min]="1" [max]="20"></p-slider>
            </div>

            <div class="slider-group w-10rem" *ngIf="isDrawable.circle">
                <p class="mb-2">Stroke: </p>
                <p-slider [(ngModel)]="circleStrokeWidth" [min]="1" [max]="20"></p-slider>
            </div>
        </div>
    </ng-template>
    <div *ngIf="loading" class="flex w-full justify-content-center">
        <p-progressSpinner
                styleClass="w-4rem h-4rem"
                strokeWidth="4"
                animationDuration="1s"/>
    </div>
    <canvas id="fabricCanvas"></canvas>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" (onClick)="dialogVisible = false"/>
        <p-button label="Save" [loading]="uploadingImageLoading" (onClick)="save()" [disabled]="isSaveDisabled()"/>
    </ng-template>
</p-dialog>
